export default "__VITE_ASSET__RGC589tN__"